import { useSearchParams } from "react-router-dom";
import { AuthLayout } from "../../components/domain/auth/AuthLayout";
import { ForgotPasswordForm } from "../../components/domain/auth/ForgotPasswordForm";
import { useForgotPassword } from "./useForgotPassword";
import { asInternalPath } from "../../lib/internal_path";
import { ROUTES } from "../../route_paths";

/** Top-level shared forgot-password page. ?from=<login-path> controls the back-to-login link. */
export default function ForgotPassword() {
  const [searchParams] = useSearchParams();
  const backToLoginHref = asInternalPath(searchParams.get("from")) ?? ROUTES.signIn.path();
  const { email, setEmail, sent, error, loading, handleSubmit } = useForgotPassword();

  return (
    <AuthLayout>
      <ForgotPasswordForm
        email={email}
        setEmail={setEmail}
        sent={sent}
        error={error}
        loading={loading}
        onSubmit={handleSubmit}
        backToLoginHref={backToLoginHref}
      />
    </AuthLayout>
  );
}
